import { Link } from 'react-router-dom'
import { InvoiceBadge } from './InvoiceBadge.js'
import { useTenantInvoices } from '../hooks/useInvoices.js'
import { fmtDate, fmtMoney } from '../format.js'

/**
 * Invoices tab under tenant detail. A compact per-tenant list; each row links
 * to the full invoice detail page where the mark-paid / void actions live.
 */
export function TenantInvoicesTab({ tenantId }: { tenantId: string }) {
  const query = useTenantInvoices(tenantId)
  const invoices = query.data?.invoices ?? []

  return (
    <div>
      <div className="admin-page-head" style={{ marginBottom: 14 }}>
        <Link
          to={`/admin/invoices?tenant_id=${tenantId}`}
          className="admin-btn admin-btn-sm"
        >
          Open in invoices view
        </Link>
      </div>

      {query.isLoading ? (
        <p className="admin-audit-meta">Loading invoices…</p>
      ) : query.isError ? (
        <p className="admin-audit-meta">Couldn't load invoices.</p>
      ) : invoices.length === 0 ? (
        <div className="admin-card">
          <div className="admin-empty">No invoices for this tenant yet.</div>
        </div>
      ) : (
        <div className="admin-card" style={{ padding: 0 }}>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Invoice #</th>
                  <th>Period</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((inv) => (
                  <tr key={inv.id}>
                    <td data-label="Invoice #">
                      <Link to={`/admin/invoices/${inv.id}`}>
                        {inv.invoice_number}
                      </Link>
                    </td>
                    <td className="admin-audit-meta" data-label="Period">
                      {fmtDate(inv.period_start)} – {fmtDate(inv.period_end)}
                    </td>
                    <td data-label="Amount">
                      {fmtMoney(inv.amount_centavos)}
                    </td>
                    <td data-label="Status">
                      <InvoiceBadge status={inv.status} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}
